/* global ace */
import mpFonts from 'common/stylesheets/mixins/fonts.json';
import * as colors from 'common/util/colors';

ace.define(`ace/theme/mixpanel`, [`require`, `exports`, `module`, `ace/lib/dom`], function (acequire, exports) {
  exports.isDark = false;
  exports.cssClass = `ace-mixpanel`;
  exports.cssText = `
.ace-mixpanel .ace_gutter {
  background: ${colors.secondaryBackgroundColor};
  border-right: 1px solid ${colors.componentOutlineColor};
  color: ${colors.primaryTextColor};
}

.ace-mixpanel .ace_print-margin {
  width: 1px;
  background: #e8e8e8
}

.ace-mixpanel .ace_gutter .ace_layer.ace_gutter-layer {
  max-width: 52px;
  min-width: 52px;
}

.ace-mixpanel {
  background-color: ${colors.backgroundColor};
  color: ${colors.secondaryTextColor};
  font-family: ${mpFonts.fontFamilyMono};
  font-size: 14px;
  font-variant-ligatures: none;
}

.ace-mixpanel.ace_autocomplete {
  font-family: ${mpFonts.fontFamilyPrimary};
  font-weight: 500;
  width: 360px;
}

.ace-mixpanel .ace_cursor {
  color: #74739E;
  border-left: 1px solid
}

.ace-mixpanel .ace_marker-layer .ace_selection {
  background: rgba(189, 213, 252, 0.3);
}

.ace-mixpanel.ace_multiselect .ace_selection.ace_start {
  box-shadow: 0 0 3px 0px #FFFFFF;
  border-radius: 2px
}

.ace-mixpanel .ace_marker-layer .ace_step {
  background: rgb(255, 255, 0)
}

.ace-mixpanel .ace_marker-layer .ace_bracket {
  margin: -1px 0 0 -1px;
  border: 1px solid #BFBFBF
}

.ace-mixpanel .ace_marker-layer .ace_active-line {
  background: ${colors.gray2};
}

.ace-mixpanel .ace_gutter-active-line {
  background-color: ${colors.gray2};
}

.ace-mixpanel .ace_marker-layer .ace_selected-word {
  border: 1px solid #BDD5FC
}

.ace-mixpanel .ace_invisible {
  color: #BFBFBF
}

.ace-mixpanel .ace_keyword,
.ace-mixpanel .ace_meta,
.ace-mixpanel .ace_support.ace_constant.ace_property-value {
  color: #92188c
}

.ace-mixpanel .ace_keyword.ace_other.ace_unit {
  color: #96DC5F
}

.ace-mixpanel .ace_constant.ace_language {
  color: #39946A
}

.ace-mixpanel .ace_constant.ace_numeric {
  color: #46A609
}

.ace-mixpanel .ace_constant.ace_character.ace_entity {
  color: #BF78CC
}

.ace-mixpanel .ace_invalid {
  background-color: #FF002A
}

.ace-mixpanel .ace_fold {
  background-color: #AF956F;
  border-color: #000000
}

.ace-mixpanel .ace_storage,
.ace-mixpanel .ace_support.ace_class,
.ace-mixpanel .ace_support.ace_function,
.ace-mixpanel .ace_support.ace_other,
.ace-mixpanel .ace_support.ace_type {
  color: #a75c11
}

.ace-mixpanel .ace_string {
  color: #6764c7
}

.ace-mixpanel .ace_comment {
  color: #578C4E
}

.ace-mixpanel .ace_entity.ace_name.ace_tag,
.ace-mixpanel .ace_entity.ace_other.ace_attribute-name {
  color: #a75c11
}

.ace-mixpanel .ace_indent-guide {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y
}

.ace-mixpanel .ace_search {
  background-color: #f3f4f8;
  border: 1px solid #d8e0ea;
}

.ace-mixpanel .ace_searchbtn.prev, .ace-mixpanel .ace_searchbtn.next {
  height: 22px;
  padding: 0px;
  vertical-align: top;
  width: 22px;
}

.ace-mixpanel .ace_searchbtn.prev:after, .ace-mixpanel .ace_searchbtn.next:after {
  position: absolute;
  left: 7px;
  top: 7px;
}
`;

  const dom = acequire(`../lib/dom`);
  dom.importCssString(exports.cssText, exports.cssClass);
});
